// metaKey on Mac, ctrlKey on other, used when doing undo / redo
export const control_key = (e) => (navigator.platform.indexOf('Mac') > -1 ? e.metaKey : e.ctrlKey)

// option (alt) key on Mac, ctrl on other, column reorder
export const mac_ALT_other_CTRL = (e) =>
  navigator.platform.indexOf('Mac') > -1 ? e.altKey : e.ctrlKey
